import Vue from 'vue'
const filters = {
  filterType(val) {
    val = val ? parseInt(val) : ''
    let str = ''
    switch (val) {
      case 1:
        str = '移动话费'
        break
      case 2:
        str = '联通话费'
        break
      case 3:
        str = '电信话费'
        break
      case 4:
        str = '中石化'
        break
      case 5:
        str = '腾讯视频'
        break
      case 6:
        str = '优酷'
        break
      case 7:
        str = '爱奇艺'
        break
      case 8:
        str = '芒果TV'
        break
      case 9:
        str = 'QQ音乐'
        break
      case 10:
        str = '网易云音乐'
        break
      case 11:
        str = '喜马拉雅'
        break
      case 12:
        str = '酷我音乐'
        break
      case 13:
        str = '百度网盘'
        break
      case 14:
        str = '懒人听书'
        break
      case 15:
        str = '酷狗音乐'
        break
      case 16:
        str = '知乎'
        break
      case 17:
        str = '掌阅'
        break
      case 18:
        str = '蜻蜓FM'
        break
      case 19:
        str = '青桔'
        break
      case 20:
        str = '京东e卡'
        break
      case 21:
        str = 'Keep会员'
        break
      case 22:
        str = 'e袋洗'
        break
      case 23:
        str = '搜狐视频'
        break
      case 24:
        str = '滴滴青桔'
        break
      case 25:
        str = '咪咕视频'
        break
      case 26:
        str = '哔哩哔哩'
        break
      case 27:
        str = '咪咕'
        break
      case 28:
        str = '樊登读书'
        break
      case 29:
        str = '凯叔讲故事'
        break
      case 30:
        str = '百度文库'
        break
      case 31:
        str = 'WPS'
        break
      case 32:
        str = '得到'
        break
      case 33:
        str = 'QQ阅读'
        break
      case 34:
        str = '美团外卖'
        break
      case 35:
        str = '饿了么'
        break
      case 36:
        str = '瑞幸咖啡'
        break
      case 37:
        str = '奈雪的茶'
        break
      case 38:
        str = '腾讯体育'
        break
      case 39:
        str = 'B站'
        break
      case 40:
        str = '腾讯文学QQ阅读'
        break
      case 41:
        str = '天猫'
        break
      case 42:
        str = '百果园'
        break
      case 43:
        str = '高德'
        break
      case 44:
        str = '悦途出行'
        break
      case 45:
        str = '哈啰'
        break
      case 46:
        str = '肯德基'
        break
      case 47:
        str = '天游'
        break
      case 48:
        str = '久游'
        break
      case 49:
        str = '战火互娱'
        break
      case 50:
        str = '网龙'
        break
      case 51:
        str = '快手币'
        break
      case 52:
        str = '抖音币'
        break
      case 53:
        str = '陌陌币'
        break
      case 54:
        str = '陌陌会员'
        break
      case 55:
        str = '作业帮'
        break
      case 56:
        str = '南瓜电影'
        break
      case 57:
        str = '钻石会员'
        break
      case 58:
        str = '新浪微博'
        break
      case 59:
        str = '迅雷超级会员'
        break
      case 1001:
        str = '乐游权益卡'
        break
      case 1002:
        str = 'Q币'
        break
      case 1003:
        str = '泰岳权益卡'
        break
      case 1004:
        str = '网易游戏'
        break
      case 1005:
        str = '骏卡益享卡'
        break
      case 1006:
        str = '骏网常盈卡'
        break
      case 1007:
        str = '骏卡汇玩卡'
        break
      case 1008:
        str = '通兑一卡通'
        break
      case 1009:
        str = 'YY'
        break
      case 1010:
        str = '虎牙'
        break
      case 1011:
        str = '盛大点券'
        break
      case 1012:
        str = '智选一卡通'
        break
      case 1013:
        str = '聚力一卡通'
        break
      case 1014:
        str = '骏网中顶卡'
        break
      case 1015:
        str = '汇元智付卡'
        break

      default:
        str = ''
    }
    return str
  },
}
export default Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})



// WEBPACK FOOTER //
// ./src/filters.js